import { Component, TemplateRef, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, AfterViewInit, Renderer2, ChangeDetectorRef } from '@angular/core';
import { OrderService } from '@app/cp/shared/services/order.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { Subscription } from 'rxjs';
import { SelectionEvent, ColumnComponent } from '@progress/kendo-angular-grid';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { OrderBillBus } from '@app/cp/shared/models/OrderBillBus';
import { OrderBillDetailsBus } from '@app/cp/shared/models/OrderBillDetailsBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'bill-detail-items',
    templateUrl: './bill-detail-items.component.html',
    styleUrls: ['./bill-detail-items.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BillDetailItemsComponent extends BaseGridEditLineComponent<OrderBillDetailsBus, null, OrderService>  {

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: OrderService, featureFlagService: FeatureFlagService) {
    super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.disableCpSearchDialog();
        this.className = "OrderBillDetailsBus";
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'orderBillDetailId': new UntypedFormControl(),
            'orderDetailId': new UntypedFormControl(),
            'orderBillId': new UntypedFormControl(),
            'orderId': new UntypedFormControl(),
            'inventoryNumber': new UntypedFormControl(),
            'inventoryDesc': new UntypedFormControl(),
            'totalReceived': new UntypedFormControl(),
            'quantityReceived': new UntypedFormControl(),
            'quantity': new UntypedFormControl(),
            'price': new UntypedFormControl(),
            'quantityBilled': new UntypedFormControl()
        });
        this.disableCpSearchDialog();
    }
    setForm() {
        this.editForm.patchValue({
            orderBillDetailId: this.selectedData.orderBillDetailId,
            orderDetailId: this.selectedData.orderDetailId,
            orderBillId: this.selectedData.orderBillId,
            orderId: this.selectedData.orderId,
            inventoryNumber: this.selectedData.inventoryNumber,
            inventoryDesc: this.selectedData.inventoryDesc,
            totalReceived: this.selectedData.totalReceived,
            quantity: this.selectedData.quantity,
            price: this.selectedData.price,
            quantityBilled: this.selectedData.quantityBilled
        });
    }
    test() {
    }
}
